import {
  AfterViewInit,
  Component,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LOAN_PRODUCT_TYPE } from 'apps/di-ld/src/app/core/constant/base.enum';
import { ILoanProduct } from 'apps/di-ld/src/app/core/interfaces';

@Component({
  selector: 'web-di-ld-card-product-shelf',
  templateUrl: './card-product-shelf.component.html',
  styleUrls: ['./card-product-shelf.component.scss'],
})
export class CardProductShelfComponent implements OnInit, AfterViewInit {
  @Input() productDetail!: ILoanProduct;
  public lang: string;
  public SMART_MONEY = LOAN_PRODUCT_TYPE.SMARTMONEY;
  public paymentTermSM = 60;
  public PAYDAY = LOAN_PRODUCT_TYPE.PAYDAY;
  public THUNGNGERN = LOAN_PRODUCT_TYPE.THUNGNGERN;

  constructor(private translocoService: TranslocoService) {
    this.lang = this.translocoService.getActiveLang();
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    // this.innerWidth = window.innerWidth;
  }

  private getTimeRemaining(endtime: string) {
    if (endtime) {
      const currentDate: any = new Date();
      const deadline: any = new Date(endtime);

      const total = Date.parse(deadline) - Date.parse(currentDate);
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));

      return {
        total,
        days,
        hours,
        minutes,
        seconds,
      };
    }
    return;
  }

  public initializeClock(id: any, endtime: any) {
    const clock: any = document.getElementById(id);
    const daysSpan = clock.querySelector('.days');
    const hoursSpan = clock.querySelector('.hours');
    const minutesSpan = clock.querySelector('.minutes');
    const secondsSpan = clock.querySelector('.seconds');
    const time = this.getTimeRemaining(endtime);

    const timeinterval = setInterval(() => {
      const t = this.getTimeRemaining(endtime);
      const day = this.translocoService.translate(
        'loanProductShelf.productDetail.day'
      );
      const hour = this.translocoService.translate(
        'loanProductShelf.productDetail.hour'
      );
      if (t) {
        clock.innerHTML =
          t.days + ' ' + day + ' ' + t.hours + ' ' + hour + ' ' + t.seconds; // + t.minutes + ' นาที ' + t.seconds + ' วินาที '
        if (t.total <= 0) {
          clearInterval(timeinterval);
        }
      }
    }, 1000);

    function updateClock() {
      if (time) {
        daysSpan.innerHTML = time.days;
        hoursSpan.innerHTML = ('0' + time.hours).slice(-2);
        minutesSpan.innerHTML = ('0' + time.minutes).slice(-2);
        secondsSpan.innerHTML = ('0' + time.seconds).slice(-2);

        if (time.total <= 0) {
          clearInterval(timeinterval);
        }
      }
    }

    updateClock();
    setInterval(updateClock, 1000);
  }

  public getProductImage(type?: string) {
    switch (type) {
      case LOAN_PRODUCT_TYPE.PAYDAY:
        return 'assets/images/product-shelf/Payday.png';
      case LOAN_PRODUCT_TYPE.THUNGNGERN:
        return 'assets/images/product-shelf/100k.png';
      case LOAN_PRODUCT_TYPE.SMARTMONEY:
        return 'assets/images/product-shelf/smart-money.png';
      default:
        return '';
    }
  }

  public getTextLabel(type?: string) {
    switch (type) {
      case LOAN_PRODUCT_TYPE.PAYDAY:
        return this.translocoService.translate(
          'loanProductShelf.productDetail.recommend'
        );
      case LOAN_PRODUCT_TYPE.THUNGNGERN:
        return this.translocoService.translate(
          'loanProductShelf.productDetail.recommend'
        );
      case LOAN_PRODUCT_TYPE.SMARTMONEY:
        return this.translocoService.translate(
          'loanProductShelf.productDetail.new'
        );
      default:
        return '';
    }
  }

  public getImageLabel(type?: string) {
    switch (type) {
      case LOAN_PRODUCT_TYPE.PAYDAY:
        return 'assets/images/product-shelf/hot-tag.svg';
      case LOAN_PRODUCT_TYPE.THUNGNGERN:
        return 'assets/images/product-shelf/hot-tag.svg';
      case LOAN_PRODUCT_TYPE.SMARTMONEY:
        return 'assets/images/product-shelf/new-tag.svg';
      default:
        return '';
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    // setTimeout(() => {
    // this.initializeClock('timer', this.productDetail?.limitTime);
    // }, 100);
  }
}
